module.exports = __webpack_public_path__ + "static/media/bussula_background.ef68b013.svg";